class Cloud {
    #items

    #sortArray(array) {
        for (let idx = array.length - 1; idx > 0; idx--) {
            // pseudo-random numbers are fine here; they do the sort.
            // eslint-disable-next-line sonarjs/pseudo-random
            const swap = Math.floor(Math.random() * (idx + 1));
            [
                array[idx],
                array[swap]
            ] = [
                    array[swap],
                    array[idx]
                ]
        }

        return array
    }

    /** @param {HTMLElement} item */
    #placeItem(item) {
        // interactive elements shall be larger than eyecandy
        const fontSizeOffset = item.classList.contains("eyecandy") ? .75 : 1
        // pseudo-random numbers are fine because they are used only for presentation.
        // eslint-disable-next-line sonarjs/pseudo-random
        const fontSize = Math.random() / 2 + fontSizeOffset
        // pseudo-random numbers are fine because they are used only for presentation.
        // eslint-disable-next-line sonarjs/pseudo-random
        const translateY = .7 * (Math.random() - 1) * 100
        // pseudo-random numbers are fine because they are used only for presentation.
        // eslint-disable-next-line sonarjs/pseudo-random
        const opacity = item.classList.contains("eyecandy") ? Math.random() / 3 + .5 : 1

        item.style.setProperty("--fontSize", fontSize + "em")
        item.style.setProperty("--transform", `translateY(${translateY}%)`)
        item.style.setProperty("--opacity", opacity.toString())

        return item
    }

    /** @param {HTMLDListElement} parent */
    constructor(parent) {
        this.#items = Array.from(
            parent.querySelectorAll(".box, .eyecandy"),
            item => this.#placeItem(item)
        )
        parent.replaceChildren(...this.#sortArray(this.#items))
    }
}

document.querySelectorAll("[id$=Cloud]")
    .forEach(cloud => new Cloud(cloud))